import * as React from "react";
import { useState } from "react";
import { useAuthStore } from "../hooks/useAuthStore";
import { postCommandToController } from "../hooks/useRequests";
import LocalConfig from "../settings/LocalConfig";
const VersionInfo = () => {
//    const frontVersion = "1.5.0.2";
    const authStore = useAuthStore();
    const [versionInfo, setVersionInfo] = useState({});

    const fillParams = async () => {
        const res = await postCommandToController('system', 'GetVersionInfo', "", authStore, true);
        const obj = Object.assign(res?.data?.VersionInfo || {},
            { FrontVersion: LocalConfig.getValue("FrontVersion", "","/versionInfo.json")}
        );
        setVersionInfo(obj);
    }

    React.useEffect(() => {
        fillParams()
    }, []);

    return (
        <span className="version-info-container">
            Version {versionInfo["Version"]}-{versionInfo["FrontVersion"]}
        </span>
    )
}
export default VersionInfo;